import {get} from 'lodash';

import {EVENT_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

export function generateOnPress({
  item,
  setSelectedSortParam,
  goBack,
  recordsName,
  lastPaidRank,
}: any) {
  return () => {
    setSelectedSortParam({recordsName, sortParam: item});
    if (recordsName.startsWith('REPORT_CLIENT_TO_CONTACT')) {
      sendSortEvent({
        sortType: item.analylicsTag,
        reportName: 'clients_to_contact',
        filterType: recordsName
          .replace('REPORT_CLIENT_TO_CONTACT_', '')
          .toLowerCase(),
        lastPaidRank: lastPaidRank,
      });
    }
    if (recordsName.startsWith('REPORT_ALL_FRONTLINE_COACHES')) {
      sendSortEvent({
        sortType: item.analylicsTag,
        reportName: 'REPORT_ALL_FRONTLINE_COACHES',
        lastPaidRank: lastPaidRank,
      });
    }
    goBack();
  };
}

export const generateOnInfoPress = ({item, onShowInfoPopover, tt}: any) => {
  return () => {
    onShowInfoPopover({
      heading: tt(
        `sortOptionLabel-${get(item, 'key', '')}`,
        get(item, 'label', ''),
      ),
      body: tt(
        `sortOptionDescription-${get(item, 'key', '')}`,
        get(item, 'description', ''),
      ),
    });
  };
};

const sendSortEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
  eventName: EVENT_NAMES.sortEvent,
});
